
  import { Component, Vue }               from 'vue-property-decorator';
  import { Action, Getter }               from 'vuex-class';
  import { EventBus,
           ResponsiveUiHelper,
           ConfigService,
           ConfigThemeService,
           BotInitializationService }     from '../..';

  import   ChatboxPanelComponent          from '../messages/ChatboxPanelComponent.vue';


  @Component({
    name: 'EmbeddedWidgetComponent',
    components: {
      ChatboxPanelComponent,
    }
  })
  export default class EmbeddedWidgetComponent extends Vue {
    @Action('setConversationPanelState', { namespace: 'conversationSession' }) setConversationPanelState: any;
    @Getter('isPresentationAvatarAllowed', { namespace: 'conversationSession' }) isPresentationAvatarAllowed!: boolean;
    
    isFullscreenDisplay: boolean = false;

    get rootContainerStyles() {
      return ConfigThemeService.getEmbeddedModeStyles(this.$vuetify);
    }

    get conversationPanelAnimation() {
      return ConfigThemeService.getChatboxPanelAnimation();
    }

    created() {
      EventBus.$on('ON_RESIZE_SCREEN_MODE', (isFullscreen: boolean) => {
        this.isFullscreenDisplay = isFullscreen;
        BotInitializationService.toggleSynapseClassInDOM(isFullscreen,  ConfigService.getElementClassOrIdToHideInFullScreenMode(),  ConfigService.getElementClassOrIdToHideInFullScreenModePrefixed());
        BotInitializationService.toggleSynapseClassInDOM(isFullscreen,  "body",  ConfigService.getSynapseClassToHideScrollbar());
      });
      this.isFullscreenDisplay = ResponsiveUiHelper.isFullscreenDisplay(this.$vuetify);
      BotInitializationService.toggleSynapseClassInDOM(this.isFullscreenDisplay,  ConfigService.getElementClassOrIdToHideInFullScreenMode(),  ConfigService.getElementClassOrIdToHideInFullScreenModePrefixed());
      BotInitializationService.toggleSynapseClassInDOM(this.isFullscreenDisplay,  "body",  ConfigService.getSynapseClassToHideScrollbar());
    }

    mounted() {
      ConfigService.isExternalIntegration() ? ResponsiveUiHelper.hideChatbox() 
                                            : ResponsiveUiHelper.showChatbox();
      EventBus.$emit('ON_WIDGET_LOADED_EVT');
    }

    beforeDestroy() {
      EventBus.$off('ON_RESIZE_SCREEN_MODE');
    }
  }
